export default {
  'zh-CN': {
    to: '至',
    forever: '永久',
    displayAll: '显示全部',
    name: '姓名',
    organizationDepartment: '组织部门',
    jobNumber: '工号'
  },
  'en': {
    to: 'To',
    forever: 'Permanent',
    displayAll: 'Show all',
    name: 'Name',
    organizationDepartment: 'Primary Organization',
    jobNumber: '工号'
  }
}
